import { Card } from "../common/Card";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export function TopAgentsChart({ topRevenueAgents, loading }) {
  return (
    <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
      <h3 className="mb-6 text-[#1A1A1A]">Top 10 Revenue Agents</h3>

      {loading ? (
        <div className="h-[350px] flex items-center justify-center">
          <div className="w-8 h-8 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin" />
        </div>
      ) : topRevenueAgents?.length > 0 ? (
        <ResponsiveContainer width="100%" height={350}>
          <BarChart data={topRevenueAgents} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis type="number" stroke="#6B7280" />
            <YAxis
              dataKey="accountName"
              type="category"
              width={150}
              stroke="#6B7280"
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "white",
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
              }}
              formatter={(value) => `$${value.toLocaleString()}`}
            />
            <Bar dataKey="revenue" fill="#1E61DC" radius={[0, 4, 4, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="h-[350px] flex items-center justify-center text-gray-500">
          No agent revenue data available
        </div>
      )}
    </Card>
  );
}
